import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export const isHoursBlock = (e) => e?.response?.data?.detail?.code === "OUTSIDE_OPERATING_HOURS";

// Shown when the server blocks a booking outside operating hours (enforcement on).
export function HoursOverrideDialog({ prompt, onCancel, onConfirm, busy }) {
  const [reason, setReason] = useState("");
  return (
    <Dialog open={!!prompt} onOpenChange={(v) => !v && onCancel()}>
      <DialogContent className="bg-white max-w-md" data-testid="hours-override-dialog">
        <DialogHeader><DialogTitle>Outside operating hours</DialogTitle><DialogDescription>{prompt?.msg}</DialogDescription></DialogHeader>
        {prompt?.can_override ? (
          <div>
            <label htmlFor="hours-override-reason" className="text-xs font-medium text-slate-600">Reason to book anyway (saved in the audit log)</label>
            <textarea id="hours-override-reason" value={reason} onChange={(e) => setReason(e.target.value)} rows={3} data-testid="hours-override-reason" className="mt-1 w-full rounded-md border border-slate-200 p-2 text-sm" />
          </div>
        ) : <p className="text-sm text-slate-600" data-testid="hours-override-denied">Choose a time within opening hours, or ask an owner/admin to book it.</p>}
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} data-testid="hours-override-cancel">Change time</Button>
          {prompt?.can_override && <Button className="bg-slate-900 text-white" disabled={!reason.trim() || busy} onClick={() => onConfirm(reason.trim())} data-testid="hours-override-confirm">Book anyway</Button>}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
